<script>
/**
 * Detailed budget report
 * SLUG: /costs-detailed-budget-report
 * This has nothing to do with budgets - mistake in naming of the component.
 */
import ProjectBudgetService from "@/services/ProjectBudgetService";
import CostSubmenu from "./components/CostSubmenu";
import VBalance from "@/components/Momentum/VBalance";
import { mapGetters } from "vuex";
import VListVouchers from "@/components/Costs/VListVouchers";

export default {
    props: {
        project_id: {}
    },
    components: { CostSubmenu, VBalance, VListVouchers },
    data() {
        return {
            loading: true,
            entries: [],
            header: [],
            oview: {},
            BK: false,
            showModal: false,
            selYear: "",
            selMon: "",
            view: "main",
            ctxCategory: "",
            budget_sum: 0
        };
    },
    computed: {
        ...mapGetters("auth", ["getAclMap"])
    },
    async created() {
        this.BK = this.$aclCan(this.$ACL.CUSTOM_PLANNING_BK_SH_NC);
        await this.fetchData();
        this.loading = false;
    },

    methods: {
        async fetchData() {
            try {
                const { data } = await ProjectBudgetService.GET_detailedReport(
                    this.project_id
                );
                this.entries = data.data.report;
                this.oview = data.data.overview;
                this.header = data.data.header;
                this.budgets = data.data.budgets;
                this.budget_sum = data.data.budget_sum;
            } catch (e) {
                console.log("fd e", e);
            }
        },
        showDetails(am, year, mon) {
            if (am == 0) {
                return;
            }

            this.selYear = year;
            this.selMon = mon;
            this.showModal = true;
        },
        showVouchers(category_id) {
            this.ctxCategory = category_id;
            this.view = "vouchers";
        }
    }
};
</script>

<template>
    <div class="v-cost-detailed-budget-report">
        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12">
                    <v-loader :loading="loading" v-if="loading" />
                    <template v-else>
                        <card body-classes="px-0">
                            <div
                                class="d-flex align-items-center mb-4 justify-content-between px-4"
                            >
                                <h2 class="">
                                    {{
                                        $t(
                                            "vouchers.cost_detailed_budget_report"
                                        )
                                    }}
                                </h2>
                                <cost-submenu
                                    :project-id="project_id"
                                    me="costs"
                                />
                            </div>
                            <hr />

                            <div class="text-right mb-3 px-4">
                                <a
                                    v-if="true"
                                    :href="
                                        `/v1/project-budgets/download-mass-detailed-report/`
                                    "
                                    class="btn btn-outline-info btn-sm"
                                    ><i class="far fa-file-csv"></i>
                                    {{
                                        $t(
                                            "vouchers.download_global_detailed_cost_file"
                                        )
                                    }}</a
                                >
                                <a
                                    v-if="true"
                                    :href="
                                        `/v1/project-budgets/download-detailed-report/${project_id}`
                                    "
                                    class="btn btn-primary btn-sm"
                                    ><i class="far fa-file-csv"></i>
                                    {{
                                        $t(
                                            "vouchers.download_detailed_cost_file"
                                        )
                                    }}</a
                                >
                            </div>
                            <div class="px-4 cat-expl">
                                <ul class="list-unstyled">
                                    <li>
                                        <span class="text-bold text-muted"
                                            >A</span
                                        >
                                        - {{ $t("vouchers.cat_A_explanation") }}
                                    </li>
                                    <li>
                                        <span class="text-bold text-muted"
                                            >B</span
                                        >
                                        - {{ $t("vouchers.cat_B_explanation") }}
                                    </li>
                                    <li>
                                        <span class="text-bold text-muted"
                                            >C</span
                                        >
                                        - {{ $t("vouchers.cat_C_explanation") }}
                                    </li>
                                    <li>
                                        <span class="text-bold text-muted"
                                            >D</span
                                        >
                                        - {{ $t("vouchers.cat_D_explanation") }}
                                    </li>
                                    <li>
                                        <span class="text-bold text-muted"
                                            >E</span
                                        >
                                        - {{ $t("vouchers.cat_E_explanation") }}
                                    </li>
                                    <li>
                                        <span class="text-bold text-muted"
                                            >F</span
                                        >
                                        - {{ $t("vouchers.cat_F_explanation") }}
                                    </li>
                                    <li>
                                        <span class="text-bold text-muted"
                                            >G</span
                                        >
                                        - {{ $t("vouchers.cat_G_explanation") }}
                                    </li>
                                </ul>
                            </div>
                            <div
                                v-for="(data, year) in oview"
                                class="px-4 overview"
                            >
                                {{ year }}

                                <div class="v_year">
                                    <div
                                        class="v_month"
                                        :class="
                                            am > 0 ? 'v_month__clickable' : ''
                                        "
                                        @click="showDetails(am, year, mon)"
                                        v-for="(am, mon) in data"
                                    >
                                        <div class="v_mname">{{ mon }}</div>
                                        <div>
                                            <div>
                                                <hide-zero
                                                    class="text-default"
                                                    :amount="am.booked"
                                                    :currency="$CURRENCY"
                                                    :decimals="false"
                                                />
                                                <span class="name-cat">A</span>
                                            </div>
                                            <div>
                                                <hide-zero
                                                    class="text-default"
                                                    :amount="am.tasks_none"
                                                    :currency="$CURRENCY"
                                                    :decimals="false"
                                                />
                                                <span class="name-cat">B</span>
                                            </div>
                                            <div>
                                                <hide-zero
                                                    class="text-default"
                                                    :amount="am.tasks_devex"
                                                    :currency="$CURRENCY"
                                                    :decimals="false"
                                                />
                                                <span class="name-cat">C</span>
                                            </div>
                                            <div>
                                                <hide-zero
                                                    class="text-default"
                                                    :amount="am.tasks_capex"
                                                    :currency="$CURRENCY"
                                                    :decimals="false"
                                                />
                                                <span class="name-cat">D</span>
                                            </div>
                                            <div>
                                                <hide-zero
                                                    class="text-default"
                                                    :amount="am.travel_total"
                                                    :currency="$CURRENCY"
                                                    :decimals="false"
                                                />
                                                <span class="name-cat">E</span>
                                            </div>
                                            <div>
                                                <span class="text-default">
                                                    <template
                                                        v-if="am.time_none > 0"
                                                    >
                                                        {{
                                                            am.time_none
                                                                | toTime
                                                        }}
                                                    </template>
                                                    <template v-else
                                                        >---</template
                                                    >
                                                </span>
                                                <span class="name-cat">F</span>
                                            </div>
                                            <div>
                                                <span class="text-default">
                                                    <template
                                                        v-if="
                                                            am.time_milestone >
                                                                0
                                                        "
                                                    >
                                                        {{
                                                            am.time_milestone
                                                                | toTime
                                                        }}
                                                    </template>
                                                    <template v-else
                                                        >---</template
                                                    >
                                                </span>

                                                <span class="name-cat">G</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr />
                            <h3 class="px-4">
                                {{ $t("vouchers.current_budgets") }}
                            </h3>
                            <div class="col-md-6">
                                <div
                                    v-if="
                                        Array.isArray(budgets) &&
                                            budgets.length == 0
                                    "
                                    class="alert alert-warning mx-2"
                                >
                                    {{
                                        $t("vouchers.no_budget_data_available")
                                    }}
                                </div>
                                <v-table class="table table-mg" v-else>
                                    <v-thead>
                                        <v-tr>
                                            <v-th>{{
                                                $t("vouchers.category")
                                            }}</v-th>
                                            <v-th class="text-right">{{
                                                $t("vouchers.amount")
                                            }}</v-th>
                                        </v-tr>
                                    </v-thead>
                                    <v-tbody>
                                        <v-tr v-for="b in budgets">
                                            <v-td>
                                                {{ b.name }}
                                                <div
                                                    v-if="b.status == 0"
                                                    class=" small text-danger"
                                                >
                                                    <i
                                                        class="far fa-exclamation-triangle"
                                                    ></i>
                                                    {{
                                                        $t(
                                                            "vouchers.nb_inactive_category"
                                                        )
                                                    }}
                                                </div>
                                            </v-td>
                                            <v-td class="text-right">
                                                {{
                                                    $n(b.budget_amount, {
                                                        style: "currency",
                                                        currency: b.currency,
                                                        currencyDisplay: "code",
                                                        maximumFractionDigits: 0,
                                                        minimumFractionDigits: 0
                                                    })
                                                }}
                                            </v-td>
                                        </v-tr>
                                    </v-tbody>
                                    <v-tfoot>
                                        <v-tr class="bg-gray">
                                            <v-th class="text-white">{{
                                                $t("sum")
                                            }}</v-th>
                                            <v-th class="text-white text-right">{{
                                                $n(budget_sum.total, {
                                                    style: "currency",
                                                    currency:
                                                        budget_sum.currency,
                                                    currencyDisplay: "code"
                                                })
                                            }}</v-th>
                                        </v-tr>
                                    </v-tfoot>
                                </v-table>
                            </div>
                        </card>
                    </template>
                </div>
            </div>
        </div>
        <portal to="modals">
            <modal
                v-if="showModal"
                size="full"
                :show="true"
                @close="showModal = false"
                class="budget-modal"
            >
                <template slot="header">
                    {{ $t("vouchers.detailed_monthly_budget") }}
                </template>

                <template slot="default">
                    <template v-if="view === 'main'">
                        <v-table class="table table-mg">
                            <v-thead>
                                <v-tr>
                                    <v-th>{{ $t("vouchers.category") }}</v-th>
                                    <v-th class="text-right">{{
                                        $t("vouchers.amount")
                                    }}</v-th>
                                </v-tr>
                            </v-thead>
                            <v-tbody>
                                <v-tr
                                    v-for="cat in entries[this.selYear][
                                        this.selMon
                                    ]"
                                >
                                    <v-td
                                        >{{ cat.name }}
                                        <base-button
                                            size="sm"
                                            type="primary"
                                            outline
                                            @click="
                                                showVouchers(
                                                    cat.voucher_category_id
                                                )
                                            "
                                            ><i
                                                class="far fa-search-plus"
                                            ></i></base-button
                                    ></v-td>
                                    <v-td class="text-right">{{
                                        $n(cat.amount, {
                                            style: "currency",
                                            currency: $CURRENCY,
                                            currencyDisplay: "code"
                                        })
                                    }}</v-td>
                                </v-tr>
                            </v-tbody>
                        </v-table>
                    </template>
                    <template v-else-if="view === 'vouchers'">
                        <div class="mb-4">
                            <base-button type="primary" @click="view = 'main'"
                                ><i class="far fa-arrow-left"></i>
                                {{
                                    $t("vouchers.go_back_to_the_report")
                                }}</base-button
                            >
                        </div>

                        <v-list-vouchers
                            :project-id="project_id"
                            :voucher-category="ctxCategory"
                            :year-month="
                                `${selYear}-${
                                    selMon < 10 ? '0' + selMon : selMon
                                }`
                            "
                        />
                    </template>
                </template>
            </modal>
        </portal>
    </div>
</template>

<style lang="scss">
.v-cost-detailed-budget-report {
    .cat-expl {
        font-size: 12px;
    }
    .name-cat {
        color: $gray-600;
        font-family: monospace;
        margin-left: 4px;
    }

    .v_year {
        display: flex;
        margin-bottom: 30px;
    }

    .v_month {
        font-size: 10px;
        text-align: right;
        border-top: 1px solid $gray-300;
        border-right: 1px solid $gray-300;
        border-bottom: 1px solid $gray-300;
        padding: 8px 4px 4px 8px;
        flex: 0 0 calc(100% / 12); /* Always 12 equal parts */
        min-width: calc(100% / 12);

        &:first-of-type {
            border-left: 1px solid $gray-300;
        }

        &__clickable:hover {
            background: $primary;
            cursor: pointer;
            * {
                color: white !important;
            }
        }

        border-radius: 6px;
    }

    .v_mname {
        text-align: left;
        color: $gray-600;
    }
}
</style>
